// LIBRARIES
import { Outlet, Navigate } from "react-router-dom";

// MISC
import { useAppSelector } from "hooks/reduxHooks";

// ASSETS

// REDUX
import { token } from "slices/sessionSlice";

// COMPONENTS

const ProtectedRoutes = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const tokenData = useAppSelector(token);
  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return tokenData !== "" ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
